/* Stone & Gray — click-and-drag horizontal scrolling for the Instafeed
   carousel. Works alongside Instafeed's native touch-swipe + click-to-open
   modal. Suppresses the click only when the user actually dragged. */

(function () {
  'use strict';

  var DRAG_THRESHOLD = 5;          // px; below this is a click, above is a drag

  function setupDrag(el) {
    if (el.dataset.sgDragInit === '1') return;
    el.dataset.sgDragInit = '1';
    /* Skip mouse-drag wiring on touch primary devices — let native touch
       scroll handle the carousel. Drag is a desktop-only enhancement. */
    if (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var dragged = 0;

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      el.classList.add('sg-dragging');
      startX = e.pageX;
      startScroll = el.scrollLeft;
      dragged = 0;
      // Stop browser native image-drag from swallowing subsequent mousemove
      e.preventDefault();
    });

    el.addEventListener('mouseleave', function () {
      isDown = false;
      el.classList.remove('sg-dragging');
    });

    document.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('sg-dragging');
    });

    el.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      dragged = Math.abs(dx);
      el.scrollLeft = startScroll - dx;
    });

    /* Suppress the click that fires after a real drag (so Instafeed doesn't
       open its modal when the user was just panning). */
    el.addEventListener('click', function (e) {
      if (dragged > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  /* Force-preload tiles' Instagram images. Instafeed's own lazy loader
     only swaps src on viewport entry — for a horizontal carousel that
     means tiles further down the scroll stay on placeholder.png until
     the user scrolls to them, causing a "blank" flash on fast swipe.
     We preload in two phases:
       phase 'first6'  — only the first 6 tiles (eager, on init)
       phase 'all'     — every tile (lazy, when #insta-feed enters viewport)
     This keeps initial page load fast and still avoids the swipe blank. */
  function preloadTiles(root, limit) {
    var swapped = 0;
    var imgs = root.querySelectorAll('img[data-instafeed-src], img.instafeed-lazy-image');
    var i = 0;
    imgs.forEach(function (img) {
      if (typeof limit === 'number' && i >= limit) return;
      var realSrc = img.getAttribute('data-instafeed-src');
      if (!realSrc) return;
      var current = img.getAttribute('src') || '';
      if (current.indexOf('cdninstagram.com') === -1 && current !== realSrc) {
        img.setAttribute('src', realSrc);
        img.classList.add('instafeed-lazy-image--handled');
        swapped++;
      }
      i++;
    });
    return swapped;
  }

  /* Strip Instafeed's `data-instafeed-prevent-touch-scroll` attribute. With
     it set, Instafeed's own JS hijacks touch events and tries to translate
     its container manually — which conflicts with our CSS-driven native
     scroll, freezing the carousel on mobile (looks blank when swiped). */
  function freeNativeScroll(root) {
    var els = root.querySelectorAll('[data-instafeed-prevent-touch-scroll]');
    els.forEach(function (el) { el.removeAttribute('data-instafeed-prevent-touch-scroll'); });
  }

  /* Inject the @handle (as a real <a> link to Instagram) + intro blurb into
     the rich-text "Follow us on Instagram" section. Uses a real <a> instead
     of a CSS ::after pseudo so the handle is clickable. */
  function injectIntro() {
    var sect = document.querySelector('[id$="__rich_text_6RpFRP"]');
    if (!sect || sect.dataset.sgIntroInjected) return;
    var block = sect.querySelector('.theme-block');
    if (!block) return;
    sect.dataset.sgIntroInjected = '1';
    var intro = document.createElement('div');
    intro.className = 'sg-instagram-intro';
    var a = document.createElement('a');
    a.className = 'sg-ig-handle';
    a.href = 'https://www.instagram.com/stone_and_gray/';
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = '@stone_and_gray';
    intro.appendChild(a);
    var p = document.createElement('p');
    p.className = 'sg-ig-blurb';
    p.textContent = 'Join our community of art lovers and stay up to date with the latest art trends, styling tips & home inspiration. Tag your space with #stoneandgray for a chance to have your art featured.';
    intro.appendChild(p);
    block.appendChild(intro);
  }

  function init() {
    injectIntro();
    var wrappers = document.querySelectorAll('#insta-feed .instafeed-new-layout-wrapper');
    wrappers.forEach(setupDrag);
    var feed = document.querySelector('#insta-feed');
    if (feed) freeNativeScroll(feed);
    if (feed && !feed.dataset.sgPreloadInit) {
      feed.dataset.sgPreloadInit = '1';
      /* Phase 1: preload the first 6 tiles immediately. */
      preloadTiles(feed, 6);
      var phaseAll = false;
      function preloadAllNow() {
        if (phaseAll) return;
        phaseAll = true;
        preloadTiles(feed);
      }
      /* Phase 2: preload the rest when carousel is near viewport. */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          if (ents.some(function (e) { return e.isIntersecting; })) { io.disconnect(); preloadAllNow(); }
        }, { rootMargin: '300px 0px' });
        io.observe(feed);
      } else {
        preloadAllNow();
      }
      /* MutationObserver: catches childList + attribute changes — Instafeed
         sets data-instafeed-src lazily, after tiles exist. Re-preload + strip
         the touch-scroll-hijack attribute on every mutation. */
      var mo = new MutationObserver(function () { if (phaseAll) preloadTiles(feed); freeNativeScroll(feed); });
      mo.observe(feed, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-instafeed-src', 'data-instafeed-prevent-touch-scroll'] });
    }
    return wrappers.length > 0 && [].every.call(wrappers, function (w) { return w.dataset.sgDragInit === '1'; });
  }

  /* Instafeed mounts client-side after its bundle loads. Poll up to 12s. */
  var attempts = 0;
  function tryInit() {
    if (init() || ++attempts > 60) return;
    setTimeout(tryInit, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();
